module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_5012.53660934.png";